import { motion, useScroll, useTransform } from "framer-motion";

const lines = ["Sports simulator", "solutions for", "your facility."];

export default function Hero() {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 900], [0, 260]);
  const scale = useTransform(scrollY, [0, 900], [1.05, 1.2]);

  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-end overflow-hidden">
      <motion.div style={{ y, scale }} className="absolute inset-0 z-0">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/da530537-6bf8-4b66-af69-f5dc06fc17f9/images/019324480eeb5589768cdce6354527b9a025d8239e6690c0cc2a58639873431e.png"
          alt="PlayVerse sports simulator bay"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#05050A] via-[#05050A]/70 to-[#05050A]/30" />
        <div className="absolute inset-0 bg-[#05050A]/30" />
      </motion.div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full pb-24 pt-48">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="flex items-center gap-4 mb-10"
        >
          <span className="h-px w-16 bg-[#00D4FF]" />
          <span className="font-mono-pv text-xs uppercase tracking-[0.3em] text-[#00D4FF]">
            PlayVerse
          </span>
        </motion.div>

        <h1 data-testid="hero-headline" className="font-heading font-extrabold tracking-tighter leading-[0.95] text-5xl sm:text-6xl lg:text-[6rem]">
          {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden pb-1">
              <motion.span
                className="block"
                initial={{ y: "115%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1.1, delay: 0.55 + i * 0.16, ease: [0.22, 1, 0.36, 1] }}
              >
                {i === 2 ? (
                  <>
                    your <span className="text-[#00D4FF]">facility.</span>
                  </>
                ) : (
                  line
                )}
              </motion.span>
            </span>
          ))}
        </h1>

        <div className="mt-12 flex flex-col md:flex-row md:items-end gap-10 md:gap-20">
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 1.2 }}
            className="max-w-md text-base md:text-lg text-white/60 leading-relaxed"
          >
            Elevate your venue with immersive golf and multi-sport simulators.
            Cutting-edge simulation technology that engages more customers and
            drives revenue.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 1.35 }}
            className="flex items-center gap-4"
          >
            <a
              href="#contact"
              data-testid="hero-cta-quote"
              className="px-8 py-4 rounded-full bg-[#007AFF] text-white font-heading font-semibold text-sm hover:bg-[#00D4FF] hover:text-[#05050A] transition-colors duration-300 shadow-[0_0_40px_rgba(0,122,255,0.5)]"
            >
              Transform Your Facility
            </a>
            <a
              href="#why"
              data-testid="hero-cta-why"
              className="px-8 py-4 rounded-full border border-white/20 text-white/80 font-heading font-semibold text-sm hover:border-[#00D4FF] hover:text-[#00D4FF] transition-colors duration-300"
            >
              Why PlayVerse
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
